import React, { useState } from "react";
import logo from "../../assets/Logo/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import LoginForm from "../../app/login/loginForm";
import SignupForm from "../../app/signup/signupForm";
import LanguageSwitcher from "../language-switcher";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const LoginSignup = ({ welcomeText, subText, login, belowText }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className="mb-2 flex w-full items-center justify-between md:hidden">
        <img
          src={logo}
          width={110}
          height={48}
          alt="myGINNE Logo"
          className="cursor-pointer"
          onClick={() =>
            window.open(`${process.env.REACT_APP_LANDING_PAGE_URL}`, "_blank")
          }
        />
        <LanguageSwitcher loading={loading} setLoading={setLoading} />
      </div>
      <div
        className={`hidden md:flex ${
          i18next.language === "ar" ? "justify-start" : "justify-end"
        } w-full`}
      >
        <LanguageSwitcher loading={loading} setLoading={setLoading} />
      </div>
      <div className="flex w-full flex-col items-start justify-start overflow-hidden md:px-20">
        <div
          className="mb-2.5 flex w-full flex-col items-start"
          style={{ marginTop: "0" }}
        >
          <h1 className="mt-8 text-2xl font-semibold text-gray-800">
            {login == true ? t("Login") : t("Sign up")}
          </h1>
          <p className="mt-2 text-sm md:text-base">
            {login == true
              ? t("Don’t have an account?")
              : t("Already have an account?")}{" "}
            <span className="text-primaryBlue font-semibold">
              {login == true ? (
                <Link to={routes.signup}>{t("Sign up")}</Link>
              ) : (
                <Link to={routes.login}>{t("Login")}</Link>
              )}
            </span>
          </p>
        </div>
        {login == true ? (
          <LoginForm setCompanyIDForPriceChecker={() => {}} />
        ) : (
          <SignupForm />
        )}
      </div>
    </>
  );
};

export default LoginSignup;
